module.exports = __webpack_public_path__ + "static/media/Donut Sugar.1ecd85a4.jpg";